import { useState } from 'react';

export const useExpandedRows = (initialExpandedRows?: Array<string>) => {
  const [expandedRows, setExpandedRows] = useState<Set<string>>(
    new Set(initialExpandedRows),
  );

  const toggleRowExpansion = (rowId: string) => {
    setExpandedRows((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(rowId)) {
        newSet.delete(rowId);
      } else {
        newSet.add(rowId);
      }
      return newSet;
    });
  };

  return { expandedRows, toggleRowExpansion };
};
